import store from "@/store";
import md5 from "md5";
import { getToken } from "@/api";

// 获取token
export function getApiToken() {
  let params = {
    ts: new Date().getTime(),
    aid: 1
  }
  console.log("获取token params", params);
  getToken(params)
    .then(res => {
      console.log("获取token成功", res);
      store.dispatch("setToken", res.data.token);
      // 本地存储token(uid)数据；清除token：localStorage.removeItem('token');
      // let paramss = {name: 'token', value: res.data.token};
      var datas = Object.assign({token: res.data.token, startTime: params.ts, expiresTime: res.data.expire});
      // var datas = Object.assign({token: res.token, startTime: params.ts, expiresTime: res.expire});
      localStorage.setItem("token", JSON.stringify(datas));
      // localStorage.setItem('token', res.data.token);
      console.log("获取token成功2", store.state.userInfo.token);
      console.log("获取token成功3", localStorage.getItem('token'));
      // 埋点事件上报 开始浏览
      return true
    })
    .catch(err => {
      console.log("获取token失败", err);
      return false
    });
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 *@function GetQueryString 获取链接后面拼接的参数
 *@param {name} 要获取的字段名
 */
export function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  } else {
    return null;
  }
}

// 埋点签名
export function setSign(data) {
  console.log('setSign1', data)
  const params = Object.assign({}, data);
  console.log('setSign2', params)
  let str = "";
  const arr = [];
  for (const k in params) {
    params[k]= Number(params[k])
    if (Object.prototype.hasOwnProperty.call(params, k)) {
      const stringify = JSON.stringify(params[k]);
      arr.push(`${k}=${stringify}`);
    }
  }
  console.log('setSign3', arr)
  const newArr = arr.sort();
  console.log('setSign4', newArr)
  newArr.forEach(element => {
    str += str.length > 0 ? `&${element}` : `${element}`;
  });
  console.log('setSign5', str)
  str += store.state.userInfo.token;
  console.log('setSign', str)
  str = md5(str);
  console.log('setSign2', str)
  return str;
}

// 对象除空后排序
export function removeProperty(data) {
  let obj = {};
  for(let key in data){
    if (data[key]==='' || data[key] === null || data[key] === undefined) {
      delete data[key]
    }
  }
  Object.keys(data).sort().forEach(item => {
    obj[item] = data[item]; 
    //执行的回调函数
  })
  return obj
}


// 复制文本
export function copy(content, msg = "복제 성공!") {
  try {
    const aux = document.createElement("textarea");
    aux.value = content;
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
    alert(msg)
  } catch (e) {
    alert("복제 실패!" + e.message);
  }
}

/**
 * 判断是否IOS 环境《ipad || iphone》
 * @returns {boolean}
 */
export function isIos() {
  const ua = navigator.userAgent;
  const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  const isIos = ipad || isIphone;
  return !!isIos;
}

/**
 * 修改当前页面地址栏参数
 * @param url
 * @param arg
 * @param arg_val
 * @returns {string|*|string}
 */
export function changeURLArg(url, arg, arg_val) {
  var pattern = arg + "=([^&]*)";
  var replaceText = arg + "=" + arg_val;
  if (url.match(pattern)) {
    var tmp = "/(" + arg + "=)([^&]*)/gi";
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match("[?]")) {
      return url + "&" + replaceText;
    } else {
      return url + "?" + replaceText;
    }
  }
}

export function numberToCurrencyNo(value) {
  if (!value) return 0
  // 获取整数部分
  const intPart = Math.trunc(value)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  // 预定义小数部分
  let floatPart = ''
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.')
  if (valueArray.length === 2) { // 有小数部分
    floatPart = valueArray[1].toString() // 取得小数部分
    return intPartFormat + '.' + floatPart
  }
  return intPartFormat + floatPart
}

/**
 * v-html格式化
 * @param url
 * @param arg
 * @param arg_val
 * @returns {string|*|string}
 */
export function EscapeHtml(str) {
  var arrEntities = {
    'lt': '<',
    'gt': '>',
    'nbsp': ' ',
    'amp': '&',
    'quot': '"'
  };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, t) {
    return arrEntities[t];
  });
}

	/**
 * 获取链接参数
 */
export function GetRequest() {
		var url = location.search; //获取url中"?"符后的字串
		var theRequest = new Object();
		if (url.indexOf("?") != -1) {
			var str = url.substr(1);
			var strs = str.split("&");
			for(var i = 0; i < strs.length; i ++) {
				theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
			}
		}
		return theRequest;
	}